import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import GlideSlider from '../base';

// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'slider',
  rewind: false,
  perTouch: 1,
  perView: 1,
  dragThreshold: false,
  focusAt: 'center',
  breakpoints: {
    [breakpoints['break-2']]: {
      focusAt: 0,
      perView: 1,
    },
  },
};

const selectors = {
  slideSelector: '[data-blog-slider-slide]',
  leftArrowSelector: '[data-blog-slider-arrow-left]',
  rightArrowSelector: '[data-blog-slider-arrow-right]',
};

export default class SectionBlogSlider extends Component {
  static selector = '[data-comp-blog-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    this.slider = new GlideSlider(containerEl, glideOptions, selectors);
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run these events after mounting the slide
    // And after transitioning between two slides
    this.sliderGlideInstance.on(['mount.after', 'run.after'], () => {
      const slideWidth = this.slider.getSliderWidth();

      this.slider.adjustSlideWidth(slideWidth);
      this.slider.handleArrowButtonState();
    });

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    this.sliderGlideInstance.mount();
  }
}
